export const CONFIG = {
  name: 'Quarterback',
  description:
    'Quarterback est une agence de marketing sportif et de communication par le sport.',

  titleSuffix: ' - Quarterback',
};

/**
 * @type {object}
 * @property {import('@shopify/hydrogen-react').CurrencyCode} currencyCode
 */
export const SHOPIFY = {
  currencyCode: 'EUR',
};

/**
 * @type {import('schema-dts').LocalBusiness}
 */
export const ORGANIZATION = {
  '@type': 'LocalBusiness',
  name: CONFIG.name,
  description: CONFIG.description,
  url: `${process.env.ORIGIN}/`,
  logo: `${process.env.ORIGIN}/static/organization-logo.png`,
  sameAs: [
    'https://www.facebook.com/AgenceQuarterback/',
    'https://www.instagram.com/agence_quarterback/',
    'https://twitter.com/quarterbackrp',
    'https://www.linkedin.com/company/quarterback/',
  ],
  email: 'contact@quarterback-group.fr',
  telephone: '+33153842500',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '27 rue Louis Pasteur',
    postalCode: '92100',
    addressLocality: 'Boulogne-Billancourt',
    addressRegion: 'Ile-de-France',
    addressCountry: 'FR',
  },
};

export const RESOLVE_RELATIONS = ['page.breadcrumbParents'];

/**
 * @typedef {Object} Locale
 * @property {string} title
 * @property {string} shortName
 * @property {string} locale
 * @property {string} shortCode
 * @property {string} pathPrefix
 */

/**
 * @type {Object<string, Locale>}
 */
export const LOCALE = {
  FR: {
    title: 'Français',
    shortName: 'FR',
    locale: 'fr-fr',
    shortCode: 'fr',
    pathPrefix: '/',
  },
  EN: {
    title: 'English',
    shortName: 'EN',
    locale: 'en-us',
    shortCode: 'en',
    pathPrefix: '/en',
  },
  ES: {
    title: 'Español',
    shortName: 'ES',
    locale: 'es-es',
    shortCode: 'es',
    pathPrefix: '/es',
  },
  PT_BR: {
    title: 'Português (Brasil)',
    shortName: 'PT',
    locale: 'pt-br',
    shortCode: 'pt-br',
    pathPrefix: '/pt-br',
  },
};

/**
 * @type {Locale[]}
 */
export const LOCALES = [LOCALE.FR, LOCALE.EN, LOCALE.ES, LOCALE.PT_BR];

export const DEFAULT_LOCALE = LOCALES[0];
